import { getResourceCaseInsensitive } from './i18n-fallback';

const EVENT_ALIASES = {};

const normalizeExperienceEvent = (value) => String(value || '').trim();

const normalizeExperienceEventNoSpaces = (value) => normalizeExperienceEvent(value).replace(/\s+/g, '');

const getEventCandidates = (event) => {
  const normalized = normalizeExperienceEvent(event);
  const key = normalizeExperienceEventNoSpaces(event).toLowerCase();
  const aliases = EVENT_ALIASES[key] || [];

  const candidates = [
    normalized,
    normalizeExperienceEventNoSpaces(normalized),
    normalized.toLowerCase(),
    ...aliases,
  ]
    .flatMap((candidate) => [
      normalizeExperienceEvent(candidate),
      normalizeExperienceEventNoSpaces(candidate),
      normalizeExperienceEvent(candidate).toLowerCase(),
    ])
    .filter(Boolean);

  return [...new Set(candidates)];
};

const findTranslationKey = (base, candidates, i18n) => {
  return candidates
    .map((candidate) => `${base}-${candidate}`)
    .find((key) =>
      i18n.exists(key) ||
      getResourceCaseInsensitive(i18n, i18n.language, key) !== undefined ||
      getResourceCaseInsensitive(i18n, 'en', key) !== undefined
    );
};

const DEFAULT_IMAGE_LAYOUT_BY_COUNT = {};

const getExperienceImageLayout = (imageCount, imageLayoutByCount = DEFAULT_IMAGE_LAYOUT_BY_COUNT) => {
  return imageLayoutByCount[imageCount] || (imageCount > 1 ? 'stack' : 'single');
};

const buildExperienceBlocks = ({
  images,
  eventCandidates,
  i18n,
  translate,
  imageLayoutByCount = DEFAULT_IMAGE_LAYOUT_BY_COUNT,
}) => {
  return images
    .map((imageGroup, index) => {
      const blockNumber = imageGroup?.order || index + 1;
      const blockKey = findTranslationKey(`experience-block${blockNumber}-text`, eventCandidates, i18n);
      const blockImages = Array.isArray(imageGroup?.images)
        ? imageGroup.images
        : [imageGroup].filter(Boolean);

      return {
        image: blockImages[0],
        images: blockImages,
        imageCount: blockImages.length,
        imageLayout: getExperienceImageLayout(blockImages.length, imageLayoutByCount),
        text: blockKey ? translate(blockKey) : '',
      };
    })
    .filter((block) => block.images.length > 0 && block.text);

};

export {
  DEFAULT_IMAGE_LAYOUT_BY_COUNT,
  EVENT_ALIASES,
  buildExperienceBlocks,
  findTranslationKey,
  getEventCandidates,
  getExperienceImageLayout,
  normalizeExperienceEvent,
  normalizeExperienceEventNoSpaces,
};